import { make } from "vuex-pathify";
import { Firebase } from "@/services/firebase";
import syncProject from "@/store/hooks/sync-project-details";

// properties
const state = {
  project: {
    status: "published",
    version: 1,
    counts: {
      total: 0,
      done: 0,
    },
  },
};

const mutations = make.mutations(state);

const getters = {
  ...make.getters(state),
};

const actions = {
  async updateCounts({ rootGetters, state, dispatch }) {
    let lists = rootGetters["lists/items"];
    let counts = {
      total: 0,
      done: 0,
    };
    Object.values(lists || {}).forEach((list) => {
      counts.total = counts.total + list.counts.total;
      counts.done = counts.done + list.counts.done;
    });

    if (
      state.project.counts.total !== counts.total ||
      state.project.counts.done !== counts.done
    ) {
      console.warn("Project counts are off... updating");
      dispatch("patch", {
        id: state.project.id,
        counts,
      });
    }
  },

  async fetchFromCache({ rootGetters, state }, project_id) {
    let db = Firebase.firestore();
    let ref = await db
      .collection("teams")
      .doc(rootGetters["user/getTeam"])
      .collection("teamProjects")
      .doc(project_id);

    // always get cache since we'll realtime sync anything new
    let doc = await ref.get({ source: "cache" });

    // fetch from server if doc exists
    if (!doc.exists) {
      console.log("Project not cached, getting tasks from server...");
      doc = await ref.get({ source: "server" });
    } else {
      console.log("Getting project from cache...");
    }

    state.project = doc.data();
  },
};

export default {
  firestorePath: "teams/{teamId}/teamProjects/{projectId}",
  firestoreRefType: "doc",
  moduleName: "project",
  statePropName: "project",
  sync: {
    debounceTimerMs: window.Cypress ? 1 : 1000,
  },
  serverChange: {
    // this keeps things up to date (url and site title)
    modifiedHook: function(updateStore, doc, id, store) {
      syncProject(doc, id, store);
      return updateStore(doc);
    },
  },
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
